import SolutionPageTemplate from "./SolutionPageTemplate";

const WorkshopsPalestrasCorporativas = () => (
  <SolutionPageTemplate
    title="Workshops e Palestras Corporativas"
    intro={[
      "Nossos workshops e palestras abordam temas relevantes para o ambiente corporativo, contribuindo para o desenvolvimento pessoal e profissional dos colaboradores.",
      "Os conteúdos são apresentados de forma prática e objetiva, trazendo reflexões e ferramentas aplicáveis ao dia a dia de trabalho.",
    ]}
    benefits={[
      "Desenvolvimento de habilidades socioemocionais",
      "Melhoria do foco e da produtividade",
      "Promoção da saúde mental e do autocuidado",
      "Fortalecimento da comunicação e das relações interpessoais",
      "Temas adaptados às necessidades da empresa",
    ]}
    sectionId="workshops-palestras-corporativas"
    modifier="solution-page--workshops"
  />
);

export default WorkshopsPalestrasCorporativas;
